
































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import headMenu from '../components/shrinkable-menu/head-menu.vue'
import shrinkableMenu from '../components/shrinkable-menu/shrinkable-menu.vue'
import tagsPageOpened from '../components/tags-page-opened.vue'
import breadcrumbNav from '../components/breadcrumb-nav.vue'
import fullScreen from '../components/fullscreen.vue'
import lockScreen from '../components/lockscreen/lockscreen.vue'
import notice from '../components/notices/notice.vue'
import util from '../lib/util'
import copyfooter from '../components/Footer.vue'
import LanguageList from '../components/language-list.vue'
import AbpBase from '../lib/abpbase'
import Oidc from 'oidc-client'
import tokenCofig from '@/lib/tokenCofig'

@Component({
  components: {
    headMenu,
    shrinkableMenu,
    tagsPageOpened,
    breadcrumbNav,
    fullScreen,
    lockScreen,
    notice,
    copyfooter,
    LanguageList,
  },
})
export default class Main extends AbpBase {
  // @Inject() private readonly isRouter
  shrink: boolean = false
  isRefresh: boolean = true
  get userName() {
    return this.$store.state.session.user ? this.$store.state.session.user.name : ''
  }
  isFullScreen: boolean = false
  messageCount: string = '0'
  get openedSubmenuArr() {
    return this.$store.state.app.openedSubmenuArr
  }
  get menuList() {
    return this.$store.state.app.menuList
  }
  get siderList() {
    return this.$store.state.app.siderList
  }
  get pageTagsList() {
    return this.$store.state.app.pageOpenedList as Array<any>
  }
  get currentPath() {
    return this.$store.state.app.currentPath
  }
  get lang() {
    return this.$store.state.app.lang
  }
  get avatorPath() {
    return localStorage.avatorImgPath
  }
  get cachePage() {
    return this.$store.state.app.cachePage
  }
  get menuTheme() {
    return this.$store.state.app.menuTheme
  }
  get mesCount() {
    return this.$store.state.app.messageCount
  }
  // RefreshPage() {
  //   console.log('alsdalfjasldfjasldfjk', localStorage.getItem('isRefresh'));
  //   if(localStorage.getItem('isRefresh') === 'true'){
  //     this.$router.go(0)
  //     localStorage.setItem('isRefresh', '')
  //   }
  // }
  init() {
    let pathArr = util.setCurrentPath(this, this.$route.name as string)
    this.$store.commit('app/updateMenulist')
    if (pathArr.length >= 2) {
      this.$store.commit('app/addOpenSubmenu', pathArr[1].name)
    }
    let messageCount = 3
    this.messageCount = messageCount.toString()
    this.checkTag(this.$route.name)
  }
  toggleClick() {
    this.shrink = !this.shrink
  }
  handleClickUserDropdown(name: string) {
    if (name === 'changePassword') {
      // util.openNewPage(this, 'ownspace_index', null, null)
      this.$router.push({
        name: 'changePassword',
      })
    } else if (name === 'logout') {
      // this.$store.commit('app/logout', this)
      localStorage.removeItem('access_token')
      Object.keys(localStorage).forEach((item) => (item.indexOf('oidc.') != -1 ? localStorage.removeItem(item) : ''))
      Object.keys(sessionStorage).forEach((item) =>
        item.indexOf('oidc.') != -1 ? sessionStorage.removeItem(item) : ''
      )
      const mgr = new Oidc.UserManager(tokenCofig)
      mgr.signoutRedirect({ id_token_hint: localStorage.getItem('id_token') })
      localStorage.removeItem('id_token')
    }
  }
  checkTag(name?: string) {
    let openpageHasTag = this.pageTagsList.some((item: any) => {
      if (item.name === name) {
        return true
      } else {
        return false
      }
    })
    if (!openpageHasTag) {
      util.openNewPage(this, name as string, this.$route.params || {}, this.$route.query || {})
    }
  }
  handleSubmenuChange(val: string) {
    // console.log(val)
  }
  beforePush(name: string) {
    if (name === 'accesstest_index') {
      return false
    } else {
      return true
    }
  }
  fullscreenChange(isFullScreen: boolean) {
    // console.log(isFullScreen);
  }
  @Watch('$route')
  routeChange(to: any) {
    this.$store.commit('app/setCurrentPageName', to.name)
    let pathArr = util.setCurrentPath(this, to.name)
    if (pathArr.length > 2) {
      this.$store.commit('app/addOpenSubmenu', pathArr[1].name)
    }
    this.checkTag(to.name)
    localStorage.currentPageName = to.name
  }
  @Watch('lang')
  langChange() {
    util.setCurrentPath(this, this.$route.name as string)
  }
  mounted() {
    this.init()
    // this.isRouter()
    // console.log(this.isRouter());
    // this.RefreshPage()
  }
  created() {
    this.$store.commit('app/setOpenedList')
  }
}
